<template>
  <div class="level-progress">
    <div class="level-progress__track">
      <div
        class="level-progress__fill"
        :style="{ width: `${progress}%` }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  progress: number
}>()
</script>

<style scoped>
.level-progress {
}


.level-progress__track {
  height: 10px;
  background: #27272A;
  border-radius: 100px;
  overflow: hidden;
}

.level-progress__fill {
  height: 100%;
  background: var(--primary-color);
  border-radius: 100px;
  transition: width 0.4s ease;
}
</style>
